import { FC, useEffect } from 'react';

interface PaystackRedirectProps {
  redirectUrl: string;
}

const PaystackRedirect: FC<PaystackRedirectProps> = ({ redirectUrl }) => {
  useEffect(() => {
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  }, [redirectUrl]);

  return (
    <div className="flex flex-col justify-center items-center h-screen">
      <p className="text-h4 mb-3 font-medium text-gray-700">
        Redirecting to Paystack checkout...
      </p>
    </div>
  );
};

export default PaystackRedirect;
